import axios from 'axios'
import i18n from './i18n'

export const baseURL = 'https://classic.devseonet.com'

let instance = axios.create({
  baseURL: baseURL,
  timeout: 10 * 60 * 1000,
})

instance.interceptors.request.use(function (config) {

  if(!config.params) {
    config.params = {}
  }

  if(!config.params.lang) {
    config.params['lang'] = i18n.locale
  }

  config.params['type'] = 'site'

  return config;
});

// function checkBasisAuth() {
//   // const user = 'comjobian';
//   // const password = '5mpKFQZmDj';
//   //
//   // const hash = btoa(user + ':' + password);
//
//   instance.get('api/helper/available-languages', {
//     // headers: {
//     //   'authorization': `Basic ${hash}`
//     // },
//   }).then(({data}) => {
//     console.log(data)
//   })
// }
//
// checkBasisAuth()

export const http = instance
